import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v2/customers/get/list.ts
var list_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var ResponseSchema = z.array(z.object({
	aiVideosPerMonth: z.number(),
	masterEcg: z.string().nullable(),
	name: z.string(),
	planName: z.string().nullable(),
	uuid: z.string(),
	vodPlanName: z.string().nullable(),
	webPlanName: z.string().nullable()
}));
var parse = parseFactory(ResponseSchema);
//#endregion
export { list_exports };

//# sourceMappingURL=list.js.map